export default __webpack_public_path__ + "static/media/partiuFilmes.ddd251c7.png";